"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetValueType1 = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApWidgetValueType1 = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement(styles_1.Wrapper, null,
        React.createElement(styles_1.Label, null, label),
        React.createElement(styles_1.Value, null, value)));
};
//# sourceMappingURL=ApWidgetValueType1.js.map